import React from "react";
import { useSelector } from "react-redux";
import Button from "../../../../../../../../common/Button";

const MoreH = () => {

  const keypad = useSelector( state => state.keypad );

  return (
    <div className="more_key">
      <table className="key_tbl" summary="키패드">
        <tbody>
        <tr>
          <td><Button className={ '0' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="0" more-key-latex="h"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_h.svg` } alt="" /></Button></td>
          <td><Button className={ '1' === keypad.moreKeyIndex ? 'fill' : null } more-key-index="1" more-key-latex="H"><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_cap_h.svg` } alt="" /></Button></td>
        </tr>
        </tbody>
      </table>
    </div>
  );

};

export default MoreH;
